export default function containsNonAlphaValidator(val) {
    const regex = /[^a-zA-Z]/;
    return val && regex.test(val);
}